module.exports = __webpack_public_path__ + "static/media/synermag.e1f11d7f.png";